import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const selectedFarmSlice = createSlice({
  name: 'selectedFarm',
  initialState: {
    uuid: '',
  },
  reducers: {
    setSelectedFarm: (state, action: PayloadAction<string>) => {
      state.uuid = action.payload;
    },
    resetSelectedFarm: (state) => {
      state.uuid = '';
    },
  },
});

export { selectedFarmSlice };
